import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { finalize, Subject, takeUntil } from 'rxjs';
import { PartnerVarenrMappingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-varenr-mapping-dto';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { VareService } from 'src/app/api/services';
import { ConfirmDialogComponent } from 'src/app/components/shared/confirm-dialog/confirm-dialog.component';
import { HistoryViewComponent } from 'src/app/components/shared/history/history-view/history-view.component';
import { IHistoryView } from 'src/app/components/shared/history/history.model';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PartnervarenrEditDialogComponent } from '../partnervarenr-edit-dialog/partnervarenr-edit-dialog.component';

@Component({
  selector: 'app-partnervarenr-list',
  templateUrl: './partnervarenr-list.component.html',
  styleUrls: ['./partnervarenr-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PartnervarenrListComponent implements OnInit {
  mappings: PartnerVarenrMappingDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = ['partnerVarenr', 'okKundeVarenr', 'actions'];

  unsubscribe$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private service: VareService,
    private auth: AuthService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) {}

  get canEdit() {
    return this.auth.isAdministrator;
  }

  ngOnInit(): void {
    this.getData();
  }

  edit(row: PartnerVarenrMappingDto) {
    const data = {
      partnerVarenrMapping: row,
    };

    let dialogRef = this.dialog.open(PartnervarenrEditDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((p) => {
      if (p) {
        this.getData();
      }
    });
  }

  add() {
    this.edit({} as PartnerVarenrMappingDto);
  }

  async getData() {
    this.loader.show();
    await this.service
      .getAllPartnerVareNrMappings({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (result: PartnerVarenrMappingDto[]) => {
          this.mappings = result;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  delete(row: PartnerVarenrMappingDto) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Er du sikker?',
        body: 'Er du sikker på at du vil slette?',
      },
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.loader.show();
        this.service
          .deletePartnerVareNrMapping({
            caller: EGIS_SERVICE_CALLER,
            id: row.id,
          })
          .pipe(
            finalize(() => {
              this.loader.hide();
            }),
            takeUntil(this.unsubscribe$),
          )
          .subscribe(
            () => {
              this.getData();
            },
            (error) => {
              this.errorHandler.HandleError(error);
            },
          );
      }
    });
  }

  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;
  historyView: IHistoryView;
  showhistory(row: PartnerVarenrMappingDto) {
    this.historyView = { entityId: row.id, historyType: AuditHistoryEnum.Varenr, title: `${row.partnerVarenr} => ${row.okKundeVarenr}` };
  }
}
